import loopback from './loopback'

/**
 * Aceite dos termos pela pessoa da sessao (TEL-2272).
 *
 * O pbxapi resolve quem e pelo `loopback-token` e guarda o aceite no core,
 * amarrado ao usuario — nao ao navegador. E por isso que NAO da para usar
 * `localStorage` aqui: o registro precisa sobreviver a troca de maquina, a
 * limpeza de dados do navegador e ao DevTools, e precisa poder ser respondido
 * depois, fora desta tela.
 *
 *   GET  /terms/me  -> { documents, pendingTerms, aceitos }
 *   POST /terms/me  -> registra o que faltava e devolve o mesmo formato
 *
 * O POST nao manda corpo de proposito: documento, versao, data e IP sao
 * decididos no servidor. Nada aqui escolhe o que fica gravado.
 */

/**
 * O produto a que este aceite se refere, e de onde o clique veio.
 *
 * `feature` e o que impede o aceite de um produto de valer por outro — e o que
 * faz o aceite do CADASTRO (que fica na conta, sem feature) tambem nao valer
 * aqui, que esta certo: quem foi criado depois pelo admin nunca passou por
 * aquela tela. `source` e so proveniencia — e nao `origin`, que neste codigo ja quer dizer
 * `scheme://host` (o `event.origin` do postMessage), para quem for investigar depois.
 *
 * Os dois passam por lista fechada no pbxapi. Sao as duas unicas coisas que
 * esta tela decide: documento, versao, data, IP e usuario sao todos carimbados
 * do lado de la.
 */
/*
 * TETO DE TEMPO, e por requisicao — nao no cliente compartilhado.
 *
 * O `loopback` e usado pelo portal inteiro, e por um estado intermediario desta
 * tela nao vale mudar o comportamento de todas as outras. O que se resolve aqui
 * e especifico: enquanto a consulta nao volta, `termsPending` fica `null`, e
 * nesse estado a pagina mostra so o cabecalho, com nada embaixo. Sem teto, uma
 * requisicao que nunca responde deixa a pessoa nisso ate recarregar a pagina.
 */
const TEMPO_LIMITE_MS = 15000

const FEATURE = 'ia4com'
const SOURCE = 'portal'

/** onde os documentos moram — os mesmos enderecos que a tela de cadastro usa */
export const TERMS_URL = 'https://www.api4com.com/terms-of-service'
export const PRIVACY_URL = 'https://www.api4com.com/privacy-policy'

/** rotulo humano de cada documento, para a tela nao imprimir `terms_of_service` */
const LABELS = {
  terms_of_service: { nome: 'Termos de Uso', url: TERMS_URL },
  privacy_policy: { nome: 'Política de Privacidade', url: PRIVACY_URL }
}

export function documentLabel (document) {
  return LABELS[document] || { nome: document, url: null }
}

/**
 * O que esta pessoa ainda precisa aceitar.
 *
 * Erro NAO vira pendencia. Se o backend nao responde, nao sabemos se falta
 * alguma coisa — e um modal bloqueante levantado por engano tira do ar uma
 * tela inteira. O estado seguro aqui e o oposto do rollout: na duvida, nao
 * atrapalhe. O pedido reaparece na proxima visita, quando houver resposta.
 */
export function fetchPendingTerms () {
  return loopback
    .get('/terms/me', { params: { feature: FEATURE }, timeout: TEMPO_LIMITE_MS })
    /*
     * `pending` e a chave DO PAYLOAD, e nao o nome da variavel daqui.
     *
     * O backend responde `{ feature, documents, pending, accepted }`. Ja esteve
     * escrito `pendingTerms` — sobra de um rename por substituicao de texto, que
     * acertou as variaveis internas e passou por cima da linha que le a
     * resposta. O efeito era `undefined || []`, lista vazia, e o pedido de
     * aceite NUNCA aparecendo: todo mundo usava o assistente sem aceitar nada,
     * sem erro em log e sem sintoma na tela.
     */
    .then(estado => (estado && estado.pending) || [])
    .catch(error => {
      console.error('[terms] nao foi possivel consultar os termos', error)
      return []
    })
}

/**
 * Registra o aceite. Diferente do GET, aqui o erro SOBE: quem clicou precisa
 * saber que nao gravou, senao o modal fecharia sobre um aceite que nao existe.
 */
export function acceptTerms () {
  return loopback
    .post('/terms/me', { feature: FEATURE, source: SOURCE }, { timeout: TEMPO_LIMITE_MS })
    // `pending`, pelo mesmo motivo do GET acima
    .then(estado => (estado && estado.pending) || [])
}

export default { fetchPendingTerms, acceptTerms, documentLabel, TERMS_URL, PRIVACY_URL }



// WEBPACK FOOTER //
// ./src/services/terms.js